

// import React, { useState, useEffect } from 'react';

// const API = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// const StarRating = ({ value, onChange, readonly = false }) => (
//   <div style={{ display: 'flex', gap: 4 }}>
//     {[1,2,3,4,5].map(star => (
//       <button key={star}
//         onClick={() => !readonly && onChange && onChange(star)}
//         style={{ background: 'none', border: 'none', cursor: readonly ? 'default' : 'pointer', padding: 0, fontSize: readonly ? 16 : 28, color: star <= value ? '#f5a623' : '#d1d5db', lineHeight: 1 }}>
//         ★
//       </button>
//     ))}
//   </div>
// );

// export default function ReviewSection({ doctorId, doctorName }) {
//   const [reviews, setReviews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [form, setForm] = useState({ patientName: '', rating: 0, review: '' });
//   const [errors, setErrors] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [success, setSuccess] = useState(false);

//   // ── Fetch reviews ──────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchReviews = async () => {
//       try {
//         const res = await fetch(`${API}/api/reviews/${doctorId}`);
//         const data = await res.json();
//         if (data.success) setReviews(data.reviews);
//       } catch (err) {
//         console.error('Failed to fetch reviews');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchReviews();
//   }, [doctorId]);

//   // ── Submit review ──────────────────────────────────────────────────────────
//   const validate = () => {
//     const e = {};
//     if (!form.patientName.trim()) e.patientName = 'Please enter your name';
//     if (!form.rating) e.rating = 'Please select a rating';
//     if (form.review.trim().length < 10) e.review = 'Review must be at least 10 characters';
//     setErrors(e);
//     return Object.keys(e).length === 0;
//   };

//   const handleSubmit = async () => {
//     if (!validate()) return;
//     setSubmitting(true);
//     try {
//       const res = await fetch(`${API}/api/reviews`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ doctorId, doctorName, ...form }),
//       });
//       const data = await res.json();
//       if (data.success) {
//         setReviews(prev => [data.review, ...prev]);
//         setForm({ patientName: '', rating: 0, review: '' });
//         setSuccess(true);
//         setTimeout(() => setSuccess(false), 3000);
//       }
//     } catch (err) {
//       console.error('Failed to submit review');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const avgRating = reviews.length > 0
//     ? (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1)
//     : null;

//   return (
//     <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>

//       {/* Write a Review */}
//       <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22 }}>
//         <h2 style={{ fontSize: 14, fontWeight: 700, color: '#19354a', marginBottom: 16, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>
//           Write a Review
//         </h2>

//         {success && (
//           <div style={{ background: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: 4, padding: '10px 14px', marginBottom: 14, fontSize: 13, color: '#2e7d32', fontWeight: 600 }}>
//             ✓ Review submitted successfully!
//           </div>
//         )}

//         <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
//           <div>
//             <label style={{ fontSize: 13, fontWeight: 600, color: '#19354a', display: 'block', marginBottom: 6 }}>Your Name *</label>
//             <input value={form.patientName} onChange={e => { setForm({ ...form, patientName: e.target.value }); setErrors({ ...errors, patientName: '' }); }}
//               placeholder="Enter your name"
//               style={{ width: '100%', padding: '10px 14px', fontSize: 13, border: `1px solid ${errors.patientName ? '#e53935' : '#dde3ea'}`, borderRadius: 4, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }} />
//             {errors.patientName && <div style={{ fontSize: 12, color: '#e53935', marginTop: 4 }}>{errors.patientName}</div>}
//           </div>

//           <div>
//             <label style={{ fontSize: 13, fontWeight: 600, color: '#19354a', display: 'block', marginBottom: 6 }}>Rating *</label>
//             <StarRating value={form.rating} onChange={r => { setForm({ ...form, rating: r }); setErrors({ ...errors, rating: '' }); }} />
//             {errors.rating && <div style={{ fontSize: 12, color: '#e53935', marginTop: 4 }}>{errors.rating}</div>}
//           </div>

//           <div>
//             <label style={{ fontSize: 13, fontWeight: 600, color: '#19354a', display: 'block', marginBottom: 6 }}>Your Review *</label>
//             <textarea value={form.review} onChange={e => { setForm({ ...form, review: e.target.value }); setErrors({ ...errors, review: '' }); }}
//               placeholder="Share your experience with this doctor..."
//               rows={4}
//               style={{ width: '100%', padding: '10px 14px', fontSize: 13, border: `1px solid ${errors.review ? '#e53935' : '#dde3ea'}`, borderRadius: 4, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', resize: 'vertical', lineHeight: 1.6 }} />
//             <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
//               {errors.review ? <div style={{ fontSize: 12, color: '#e53935' }}>{errors.review}</div> : <div />}
//               <div style={{ fontSize: 11, color: '#aaa' }}>{form.review.length}/1000</div>
//             </div>
//           </div>

//           <button onClick={handleSubmit} disabled={submitting}
//             style={{ padding: '11px 0', background: submitting ? '#aaa' : '#39a5d3', color: '#fff', border: 'none', borderRadius: 4, fontSize: 13, fontWeight: 700, cursor: submitting ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}>
//             {submitting ? 'Submitting...' : 'Submit Review'}
//           </button>
//         </div>
//       </div>

//       {/* Reviews List */}
//       <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22 }}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>
//           <h2 style={{ fontSize: 14, fontWeight: 700, color: '#19354a', margin: 0 }}>
//             Patient Reviews {reviews.length > 0 && `(${reviews.length})`}
//           </h2>
//           {avgRating && (
//             <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
//               <span style={{ fontSize: 22, fontWeight: 800, color: '#19354a' }}>{avgRating}</span>
//               <div>
//                 <StarRating value={Math.round(avgRating)} readonly />
//                 <div style={{ fontSize: 11, color: '#888' }}>{reviews.length} review{reviews.length !== 1 ? 's' : ''}</div>
//               </div>
//             </div>
//           )}
//         </div>

//         {loading ? (
//           <div style={{ textAlign: 'center', padding: '30px 0', color: '#aaa', fontSize: 13 }}>Loading reviews...</div>
//         ) : reviews.length === 0 ? (
//           <div style={{ textAlign: 'center', padding: '30px 0', color: '#aaa', fontSize: 13 }}>
//             No reviews yet. Be the first to review!
//           </div>
//         ) : (
//           <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
//             {reviews.map((r, i) => (
//               <div key={r._id || i} style={{ paddingBottom: 16, borderBottom: i < reviews.length - 1 ? '1px solid #f5f5f5' : 'none' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
//                   <div>
//                     <div style={{ fontSize: 13, fontWeight: 700, color: '#19354a' }}>{r.patientName}</div>
//                     <StarRating value={r.rating} readonly />
//                   </div>
//                   <div style={{ fontSize: 11, color: '#aaa' }}>
//                     {new Date(r.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
//                   </div>
//                 </div>
//                 <p style={{ fontSize: 13, color: '#555', lineHeight: 1.7, margin: 0 }}>{r.review}</p>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

const StarRating = ({ value, onChange, readonly = false }) => (
  <div style={{ display: 'flex', gap: 4 }}>
    {[1, 2, 3, 4, 5].map(star => (
      <button
        key={star}
        onClick={() => !readonly && onChange && onChange(star)}
        style={{ background: 'none', border: 'none', cursor: readonly ? 'default' : 'pointer', padding: 0, fontSize: readonly ? 16 : 26, color: star <= value ? '#39a5d3' : '#d1d5db', lineHeight: 1 }}
      >★</button>
    ))}
  </div>
);

export default function ReviewSection({ doctorId, doctorName }) {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ patientName: '', rating: 0, review: '' });
  const [submitStatus, setSubmitStatus] = useState('idle'); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState('');

  // ── Fetch reviews ───────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch(`${API_URL}/api/reviews/${doctorId}`);
        const data = await res.json();
        if (data.success) setReviews(data.reviews);
      } catch (err) {
        console.error('Failed to fetch reviews:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchReviews();
  }, [doctorId]);

  // ── Submit review ───────────────────────────────────────────────────────────
  const handleSubmit = async () => {
    if (!form.patientName.trim()) { setErrorMsg('Please enter your name.'); return; }
    if (form.rating === 0) { setErrorMsg('Please select a rating.'); return; }
    if (form.review.trim().length < 10) { setErrorMsg('Review must be at least 10 characters.'); return; }
    setErrorMsg('');
    setSubmitStatus('loading');

    try {
      const res = await fetch(`${API_URL}/api/reviews`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          doctorId,
          doctorName,
          patientName: form.patientName.trim(),
          rating: form.rating,
          review: form.review.trim(),
        }),
      });
      const data = await res.json();
      if (data.success) {
        setSubmitStatus('success');
        setForm({ patientName: '', rating: 0, review: '' });
      } else {
        setErrorMsg(data.message || 'Failed to submit review.');
        setSubmitStatus('error');
      }
    } catch (err) {
      setErrorMsg('Unable to connect. Please try again.');
      setSubmitStatus('error');
    }
  };

  const avgRating = reviews.length
    ? (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1)
    : null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>

      {/* ── Rating Summary ──────────────────────────────────────────────────── */}
      {reviews.length > 0 && (
        <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22, display: 'flex', alignItems: 'center', gap: 24 }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 40, fontWeight: 800, color: '#19354a', lineHeight: 1 }}>{avgRating}</div>
            <StarRating value={Math.round(avgRating)} readonly />
            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{reviews.length} review{reviews.length !== 1 ? 's' : ''}</div>
          </div>
          <div style={{ flex: 1 }}>
            {[5, 4, 3, 2, 1].map(star => {
              const count = reviews.filter(r => r.rating === star).length;
              const pct = reviews.length ? (count / reviews.length) * 100 : 0;
              return (
                <div key={star} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                  <span style={{ fontSize: 12, color: '#888', width: 14 }}>{star}</span>
                  <span style={{ fontSize: 12, color: '#f0b429' }}>★</span>
                  <div style={{ flex: 1, height: 6, background: '#eee', borderRadius: 3, overflow: 'hidden' }}>
                    <div style={{ width: `${pct}%`, height: '100%', background: '#39a5d3', borderRadius: 3 }} />
                  </div>
                  <span style={{ fontSize: 11, color: '#aaa', width: 20 }}>{count}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── Write Review Form ───────────────────────────────────────────────── */}
      <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22 }}>
        <h2 style={{ fontSize: 14, fontWeight: 700, color: '#19354a', marginBottom: 16, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>
          {submitStatus === 'success' ? 'Review Submitted' : 'Write a Review'}
        </h2>

        {submitStatus === 'success' ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#e8f5e9', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="#2e7d32"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
            </div>
            <p style={{ fontSize: 14, color: '#444', marginBottom: 8 }}>Thank you for your review!</p>
            <p style={{ fontSize: 12, color: '#888' }}>Your review will appear after approval.</p>
            <button onClick={() => setSubmitStatus('idle')} style={{ marginTop: 16, fontSize: 12, color: '#39a5d3', background: 'none', border: '1px solid #39a5d3', borderRadius: 4, padding: '6px 16px', cursor: 'pointer', fontFamily: 'inherit' }}>Write Another</button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {/* Name */}
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 6 }}>Your Name *</label>
              <input
                value={form.patientName}
                onChange={e => setForm(f => ({ ...f, patientName: e.target.value }))}
                placeholder="Enter your name"
                style={{ width: '100%', padding: '9px 12px', fontSize: 13, border: '1px solid #ddd', borderRadius: 4, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
              />
            </div>

            {/* Rating */}
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 6 }}>Rating *</label>
              <StarRating value={form.rating} onChange={r => setForm(f => ({ ...f, rating: r }))} />
            </div>

            {/* Review */}
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 6 }}>Your Review *</label>
              <textarea
                value={form.review}
                onChange={e => setForm(f => ({ ...f, review: e.target.value }))}
                placeholder="Share your experience with this doctor..."
                rows={4}
                style={{ width: '100%', padding: '9px 12px', fontSize: 13, border: '1px solid #ddd', borderRadius: 4, outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit', lineHeight: 1.6 }}
              />
              <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>{form.review.length}/1000</div>
            </div>

            {/* Error */}
            {errorMsg && (
              <div style={{ background: '#fff5f5', border: '1px solid #ffcccc', borderRadius: 4, padding: '8px 12px', fontSize: 12, color: '#c0392b' }}>{errorMsg}</div>
            )}

            {/* Submit */}
            <button
              onClick={handleSubmit}
              disabled={submitStatus === 'loading'}
              style={{ padding: '10px 0', fontSize: 13, fontWeight: 700, background: submitStatus === 'loading' ? '#a8d8ee' : '#39a5d3', color: '#fff', border: 'none', borderRadius: 4, cursor: submitStatus === 'loading' ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}
            >
              {submitStatus === 'loading' ? 'Submitting...' : 'Submit Review'}
            </button>
          </div>
        )}
      </div>

      {/* ── Reviews List ────────────────────────────────────────────────────── */}
      <div style={{ background: '#fff', border: '1px solid #eaecef', borderRadius: 4, padding: 22 }}>
        <h2 style={{ fontSize: 14, fontWeight: 700, color: '#19354a', marginBottom: 16, marginTop: 0, paddingBottom: 10, borderBottom: '1px solid #f0f0f0' }}>
          Patient Reviews {reviews.length > 0 && <span style={{ fontSize: 12, color: '#888', fontWeight: 400 }}>({reviews.length})</span>}
        </h2>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '24px 0', color: '#aaa', fontSize: 13 }}>Loading reviews...</div>
        ) : reviews.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <p style={{ fontSize: 13, color: '#888', margin: 0 }}>No reviews yet. Be the first to share your experience!</p>
          </div>
        ) : (
          reviews.map((r, i) => (
            <div key={r._id || i} style={{ paddingBottom: 16, marginBottom: 16, borderBottom: i < reviews.length - 1 ? '1px solid #f5f5f5' : 'none' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#19354a' }}>{r.patientName}</div>
                  <StarRating value={r.rating} readonly />
                </div>
                <div style={{ fontSize: 11, color: '#bbb' }}>
                  {new Date(r.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                </div>
              </div>
              <p style={{ fontSize: 13, color: '#555', lineHeight: 1.7, margin: 0 }}>{r.review}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}